import { Link } from "react-router-dom";
import { ArrowUpRight, Github, Linkedin, Twitter } from "lucide-react";

const columns = [
    {
        title: "Products",
        links: [
            { to: "/products/estamp", label: "eStamp" },
            { to: "/products/monitor", label: "Monitor" },
            { to: "/products/procurement", label: "Procurement & Contracts" },
            { to: "/products/rent", label: "Rent" },
            { to: "/products/events", label: "Events" },
        ],
    },
    {
        title: "Solutions",
        links: [
            { to: "/solutions/government", label: "Government" },
            { to: "/solutions/banking", label: "Financial Services" },
            { to: "/solutions/enterprise", label: "Enterprises" },
            { to: "/solutions/sme", label: "SMEs" },
            { to: "/solutions/property", label: "Property Management" },
        ],
    },
    {
        title: "Company",
        links: [
            { to: "/company", label: "About" },
            { to: "/support", label: "Contact" },
            { to: "/company", label: "Careers" },
            { to: "/company", label: "Partners" },
        ],
    },
    {
        title: "Resources",
        links: [
            { to: "/support", label: "Support" },
            { to: "/support", label: "Documentation" },
            { to: "/company", label: "Blog" },
            { to: "/support", label: "FAQs" },
        ],
    },
    {
        title: "Legal",
        links: [
            { to: "/company", label: "Privacy Policy" },
            { to: "/company", label: "Terms of Service" },
            { to: "/company", label: "Cookie Policy" },
        ],
    },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-[#0B1930] text-white pt-24 pb-10 relative overflow-hidden">
            <div className="hero-glow top-[-300px] left-[10%]" style={{ background: "#2563EB" }} />
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
                <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-2.5">
                            <div className="w-9 h-9 rounded-md bg-gradient-to-br from-[#E8B923] to-[#C99F0F] flex items-center justify-center text-navy font-serif text-lg font-bold">C</div>
                            <div className="flex flex-col leading-none">
                                <span className="text-white font-serif text-2xl font-semibold tracking-tight">Colecle</span>
                                <span className="text-white/50 text-[10px] font-mono tracking-[0.2em] mt-1">INC</span>
                            </div>
                        </div>
                        <p className="text-white/60 text-sm max-w-sm mt-6 leading-relaxed">
                            One Platform. Smarter Business. Enterprise software that automates processes,
                            improves visibility and helps organizations operate smarter.
                        </p>
                        <Link to="/request-demo" data-testid="footer-demo-cta" className="btn-gold text-sm mt-8">
                            Request a Demo <ArrowUpRight className="w-4 h-4" />
                        </Link>
                    </div>
                    <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-5 gap-8">
                        {columns.map((col) => (
                            <div key={col.title}>
                                <div className="text-white/40 text-[11px] font-mono tracking-[0.2em] uppercase mb-4">{col.title}</div>
                                <ul className="space-y-2.5">
                                    {col.links.map((l) => (
                                        <li key={l.label}>
                                            <Link to={l.to} className="text-white/70 hover:text-white text-sm transition">
                                                {l.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                    <div className="text-white/40 text-xs">
                        © {new Date().getFullYear()} Colecle Inc. All rights reserved.
                    </div>
                    <div className="flex items-center gap-4 text-white/50">
                        <a href="#" aria-label="Twitter" className="hover:text-white transition"><Twitter className="w-4 h-4" /></a>
                        <a href="#" aria-label="LinkedIn" className="hover:text-white transition"><Linkedin className="w-4 h-4" /></a>
                        <a href="#" aria-label="GitHub" className="hover:text-white transition"><Github className="w-4 h-4" /></a>
                    </div>
                </div>

                <div className="mt-16 select-none pointer-events-none">
                    <div className="font-serif text-[18vw] leading-[0.85] text-white/[0.04] tracking-tighter">COLECLE</div>
                </div>
            </div>
        </footer>
    );
}
